import { cx } from '@emotion/css';

import { useStyles } from './list.styles';
import { FactsCard } from '../facts-card/facts-card';
import { FactsItem } from '../facts-card/facts-card.model';

export const List = ({
  itemsFirst, itemsSecond, isSpanFirst, isSpanLast,
}: {
  itemsFirst: FactsItem[], itemsSecond?: FactsItem[], isSpanFirst?: boolean, isSpanLast?: boolean,
}): JSX.Element => {
  const classes = useStyles();
  const getItems = (items: FactsItem[]) => items.map(({
    title, content, icon, list, isReverse, isRowReverse, isRow, isWide, isNarrow, isSmallMobile,
  }) => (
        <FactsCard
          title={title}
          content={content}
          icon={icon}
          list={list}
          isReverse={isReverse}
          isRowReverse={isRowReverse}
          isRow={isRow}
          isWide={isWide}
          isNarrow={isNarrow}
          isSmallMobile={isSmallMobile}
          key={title}
        />
  ));

  return (
    <div className={classes.list}>
      {itemsFirst && (
        <div className={cx(classes.inner, classes.wide, {
          [classes.full]: isSpanFirst,
          [classes.row]: isSpanLast || !itemsSecond,
        })}>
          {getItems(itemsFirst)}
        </div>
      )}
      {itemsSecond && (
        <div className={cx(classes.inner, classes.narrow, {
          [classes.full]: isSpanLast,
          [classes.row]: isSpanFirst,
        })}>
          {getItems(itemsSecond)}
        </div>
      )}
    </div>
  );
};
